import { createFileRoute } from "@tanstack/react-router"
import { SearchValue } from "../-components/infinit-scrolling-table/extended-infinit-scrolling-table"
import { lazyImportRouteComponent } from "../../../utils/lazyImportRouteComponent"

export interface Search extends SearchValue<"/api/Person/GetPersonTable"> {
  searchString: string
  view: "table" | "list"
}

export const Route = createFileRoute("/app/contacts/")({
  component: lazyImportRouteComponent(
    () => import("./-components/PersonsPage"),
    "PersonsPage"
  ),
  validateSearch: (search: Search) => search,
})
